<template>
  <div class="container-fluid pb-150">
    <!--    Start video and panel-->
    <div class="row container-showcase mb-0 align-start justify-space-between">
      <!--      Player-->
      <v-col cols="12" class="wow fadeInLeftBig col-lg-6 col-xl-6 player">
        <player
          :poster-url="ctnShowcase.url_poster"
          :is-control-scene="false"
          :video-plr="video"
        ></player>
        <content-same-showcase
          :title="ctnShowcase.title"
          :type-show-case="Number(ctnShowcase.type_showcase)"
          :showcase-id="ctnShowcase.showcase_id"
          @selectContent="handleChangeContent"
        ></content-same-showcase>
        <div
          v-if="['lg', 'xl'].includes($vuetify.breakpoint.name)"
          class="title-demo ml-0 mt-4"
        >
          <h5>Demo {{ $t("video_analysis_title") }}</h5>
          <span>
            {{ $t("video_analysis_des") }}
          </span>
        </div>
        <!--        title showcase-->
      </v-col>
      <!--      Panel meta-->
      <v-col
        cols="12"
        class="col-xl-6 col-lg-6 mt-lg-0 mt-md-12 mt-sm-12 mt-xs-12"
      >
        <div
          v-if="['sm', 'xs', 'md'].includes($vuetify.breakpoint.name)"
          class="title-demo ml-0 mt-4"
        >
          <h5>Demo {{ $t("video_analysis_title") }}</h5>
          <span>
            {{ $t("video_analysis_des") }}
          </span>
        </div>
        <!--        meta data-->
        <transition name="slide-fade">
          <div class="wow fadeInRight" style="position: relative">
            <v-card width="100%" height="100vh">
              <v-card-text
                style="max-height: 90vh"
                class="pt-0 overflow-y-auto px-sm-0 px-xs-0 px-md-6 px-lg-0 px-xl-6"
              >
                <v-tabs color="primary" left>
                  <v-tab style="text-transform: none">Statistic by scene</v-tab>
                  <v-tab style="text-transform: none"
                    >Statistic all video
                  </v-tab>
                  <v-tab-item v-for="n in ['scene', 'video']" :key="n">
                    <!--                    meta by scene-->
                    <v-container fluid v-if="n === 'scene'">
                      <!--            Age and gender-->
                      <div class="row row--dense px-2" style="margin-top: 6px">
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[0].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Ages</span
                          >

                          <!--                          age-->
                          <v-col v-if="currentMeta && currentMeta.ages">
                            <div
                              class="row justify-start"
                              v-for="(age, idx) in currentMeta.ages"
                              :key="idx"
                            >
                              <v-chip small dark color="blue-grey">{{
                                age.id
                              }}</v-chip>
                            </div>
                          </v-col>
                        </v-col>
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[1].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Gender</span
                          >
                          <!--                          gender-->
                          <v-col v-if="currentMeta && currentMeta.genders">
                            <div
                              class="row justify-start"
                              v-for="(gender, idx) in currentMeta.genders"
                              :key="idx"
                            >
                              <v-chip small dark color="teal">{{
                                gender.id
                              }}</v-chip>
                            </div>
                          </v-col>
                        </v-col>
                      </div>
                      <!--            scene and common object-->
                      <div class="row row--dense px-2" style="margin-top: 6px">
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[2].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Scenes</span
                          >

                          <!--                          scenes-->
                          <v-col
                            v-if="currentMeta && currentMeta.scenes"
                            style="min-width: 200px"
                          >
                            <div class="row justify-start">
                              <v-chip
                                small
                                v-for="(scene, idx) in currentMeta.scenes"
                                :key="idx"
                                color="teal"
                                dark
                                class="ma-1"
                                >{{ scene }}</v-chip
                              >
                            </div>
                          </v-col>
                        </v-col>
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[3].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Common objects</span
                          >
                          <v-col
                            v-if="currentMeta && currentMeta.cmn_objs"
                            style="min-width: 200px"
                          >
                            <div class="row justify-start align-start">
                              <v-chip
                                small
                                v-for="(cmn_obj, idx) in currentMeta.cmn_objs"
                                :key="idx"
                                dark
                                color="cyan"
                                class="ma-1"
                                >{{ cmn_obj }}</v-chip
                              >
                            </div>
                          </v-col>
                        </v-col>
                      </div>
                      <!--            Celeb-->
                      <div class="row row--dense px-2" style="margin-top: 6px">
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[4].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Celeb</span
                          >

                          <!--                          scenes-->
                          <v-col
                            v-if="currentMeta && currentMeta.celebs"
                            style="min-width: 200px"
                          >
                            <div class="row justify-start">
                              <div
                                v-for="(celeb, idx) in currentMeta.celebs"
                                :key="idx"
                                class="ma-3 row no-gutters celeb-scene justify-center align-center"
                              >
                                <v-col cols="auto">
                                  <v-avatar size="70">
                                    <v-img aspect-ratio="1" :src="celeb.avt" />
                                  </v-avatar>
                                </v-col>
                                <v-col cols="auto" class="text-center">
                                  <span
                                    style="font-size: 14px; font-weight: bold"
                                    >{{ celeb.id }}</span
                                  >
                                  <div v-if="celeb.acts">
                                    <v-chip
                                      small
                                      v-for="(act, idxAct) in celeb.acts.slice(
                                        0,
                                        5
                                      )"
                                      :key="idxAct"
                                      color="teal"
                                      class="ml-1 mb-1"
                                      text-color="white"
                                    >
                                      {{ act }}
                                    </v-chip>
                                  </div>
                                  <div v-if="celeb.emts">
                                    <v-chip
                                      small
                                      v-for="(emt, idxEmt) in celeb.emts.slice(
                                        0,
                                        5
                                      )"
                                      :key="idxEmt"
                                      color="cyan"
                                      class="ml-1"
                                      text-color="white"
                                    >
                                      {{ emt }}
                                    </v-chip>
                                  </div>
                                </v-col>
                              </div>
                            </div>
                          </v-col>
                        </v-col>
                      </div>
                      <!--            Emotion and action-->
                      <div class="row row--dense px-2" style="margin-top: 6px">
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[5].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Emotions</span
                          >

                          <!--                          emotion-->
                          <v-col
                            v-if="currentMeta && currentMeta.emotions"
                            style="min-width: 200px"
                          >
                            <div class="row justify-start">
                              <v-chip
                                small
                                v-for="(emotion, idx) in currentMeta.emotions"
                                :key="idx"
                                color="cyan"
                                dark
                                class="ma-1"
                                >{{ emotion }}</v-chip
                              >
                            </div>
                          </v-col>
                        </v-col>
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[6].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Actions</span
                          >
                          <v-col
                            v-if="currentMeta && currentMeta.actions"
                            style="min-width: 200px"
                          >
                            <div class="row justify-start align-start">
                              <v-chip
                                small
                                v-for="(action, idx) in currentMeta.actions"
                                :key="idx"
                                dark
                                color="teal"
                                class="ma-1"
                                >{{ action }}</v-chip
                              >
                            </div>
                          </v-col>
                        </v-col>
                      </div>
                      <!--            Colors-->
                      <div class="row row--dense px-2" style="margin-top: 6px">
                        <v-col
                          class="model-container"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                          v-if="allModels[7].active"
                        >
                          <span style="font-weight: bold" class="pa-2"
                            >Colors</span
                          >
                          <v-col
                            v-if="currentMeta && currentMeta.colors"
                            style="min-width: 200px"
                          >
                            <div class="row justify-center">
                              <v-col cols="auto">
                                <pie-chart
                                  :data="currentMeta.colors.dist"
                                  :colors="currentMeta.colors.color"
                                />
                              </v-col>
                            </div>
                          </v-col>
                        </v-col>
                      </div>
                    </v-container>
                    <!--                    meta all video -->
                    <v-container fluid v-else>
                      <div v-if="summaryData">
                        <!--      Age Gender-->
                        <v-col cols="12">
                          <div class="row">
                            <!--          Age-->
                            <v-col
                              class="wow slideInUp content-model py-6"
                              style="
                                background-color: whitesmoke;
                                border-radius: 12px;
                              "
                            >
                              <div class="title-chart">
                                <span>Age</span>
                              </div>
                              <div
                                class="row no-gutters align-content-center container-bar-chart"
                                v-for="(age, idx) in summaryData.ages"
                                :key="idx"
                              >
                                <v-col cols="2">
                                  <span>{{ age.id }}</span>
                                </v-col>
                                <v-col cols="8">
                                  <div
                                    class="bar-chart"
                                    :style="{
                                      width:
                                        (age.total_secs / duration) * 100 + '%',
                                    }"
                                  ></div>
                                </v-col>
                                <v-col cols="1">
                                  <span style="font-weight: bold"
                                    >{{
                                      Math.round(
                                        (age.total_secs / duration) * 100
                                      )
                                    }}%</span
                                  >
                                </v-col>
                              </div>
                            </v-col>
                            <!--          Gender-->
                            <v-col
                              class="wow slideInUp content-model py-6"
                              style="
                                background-color: whitesmoke;
                                border-radius: 12px;
                              "
                            >
                              <div class="title-chart">
                                <span>Gender</span>
                              </div>
                              <div
                                class="row align-center justify-space-around"
                              >
                                <v-col cols="auto">
                                  <pie-chart
                                    :labels="
                                      summaryData.genders.map(function (obj) {
                                        return obj.id;
                                      })
                                    "
                                    :data="
                                      summaryData.genders.map(function (obj) {
                                        return obj.total_secs;
                                      })
                                    "
                                    :colors="['#00897B', '#EC407A']"
                                    :show-legend="true"
                                  ></pie-chart>
                                </v-col>
                              </div>
                            </v-col>
                          </div>
                        </v-col>
                        <!--      Scene and common object-->
                        <v-col cols="12">
                          <div class="row">
                            <!--          Scene-->
                            <v-col
                              class="content-model py-6"
                              style="
                                background-color: whitesmoke;
                                border-radius: 12px;
                              "
                            >
                              <div class="title-chart">
                                <span>Scene</span>
                              </div>
                              <div
                                class="row no-gutters align-content-center container-bar-chart px-6"
                                v-for="(scene, idx) in summaryData.scenes.slice(
                                  0,
                                  topView
                                )"
                                :key="idx"
                              >
                                <v-col cols="4">
                                  <span>{{ scene.id }}</span>
                                </v-col>
                                <v-col cols="7">
                                  <div
                                    class="bar-chart"
                                    :style="{
                                      width:
                                        (scene.total_secs / duration) * 100 +
                                        '%',
                                    }"
                                  ></div>
                                </v-col>
                                <v-col cols="1">
                                  <span style="font-weight: bold"
                                    >{{
                                      Math.round(
                                        (scene.total_secs / duration) * 100
                                      )
                                    }}%</span
                                  >
                                </v-col>
                              </div>
                            </v-col>
                            <!--          Common obj-->
                            <v-col
                              class="content-model py-6"
                              style="
                                background-color: whitesmoke;
                                border-radius: 12px;
                              "
                            >
                              <div class="title-chart">
                                <span>Common Object</span>
                              </div>
                              <div
                                class="row no-gutters align-content-center container-bar-chart px-6"
                                v-for="(
                                  cmn_obj, idx
                                ) in summaryData.cmn_objs.slice(0, topView)"
                                :key="idx"
                              >
                                <v-col cols="4">
                                  <span>{{ cmn_obj.id }}</span>
                                </v-col>
                                <v-col cols="7">
                                  <div
                                    class="bar-chart"
                                    :style="{
                                      width:
                                        (cmn_obj.total_secs / duration) * 100 +
                                        '%',
                                    }"
                                  ></div>
                                </v-col>
                                <v-col cols="1">
                                  <span style="font-weight: bold"
                                    >{{
                                      Math.round(
                                        (cmn_obj.total_secs / duration) * 100
                                      )
                                    }}%</span
                                  >
                                </v-col>
                              </div>
                            </v-col>
                          </div>
                        </v-col>
                        <!--      Emotion and action -->
                        <v-col cols="12">
                          <div class="row">
                            <!--          Emotion-->
                            <v-col
                              class="content-model py-6"
                              style="
                                background-color: whitesmoke;
                                border-radius: 12px;
                              "
                            >
                              <div class="title-chart">
                                <span>Emotion</span>
                              </div>
                              <div
                                class="row no-gutters align-content-center container-bar-chart px-6"
                                v-for="(emt, idx) in summaryData.emotions.slice(
                                  0,
                                  topView
                                )"
                                :key="idx"
                              >
                                <v-col cols="4">
                                  <span>{{ emt.id }}</span>
                                </v-col>
                                <v-col cols="7">
                                  <div
                                    class="bar-chart"
                                    :style="{
                                      width:
                                        (emt.total_secs / duration) * 100 + '%',
                                    }"
                                  ></div>
                                </v-col>
                                <v-col cols="1">
                                  <span style="font-weight: bold"
                                    >{{
                                      Math.round(
                                        (emt.total_secs / duration) * 100
                                      )
                                    }}%</span
                                  >
                                </v-col>
                              </div>
                            </v-col>
                            <!--         Action -->
                            <v-col
                              class="content-model py-6"
                              style="
                                background-color: whitesmoke;
                                border-radius: 12px;
                              "
                            >
                              <div class="title-chart">
                                <span>Action</span>
                              </div>
                              <div
                                class="row no-gutters align-content-center container-bar-chart px-6"
                                v-for="(act, idx) in summaryData.actions.slice(
                                  0,
                                  topView
                                )"
                                :key="idx"
                              >
                                <v-col cols="4">
                                  <span>{{ act.id }}</span>
                                </v-col>
                                <v-col cols="7">
                                  <div
                                    class="bar-chart"
                                    :style="{
                                      width:
                                        (act.total_secs / duration) * 100 + '%',
                                    }"
                                  ></div>
                                </v-col>
                                <v-col cols="1">
                                  <span style="font-weight: bold"
                                    >{{
                                      Math.round(
                                        (act.total_secs / duration) * 100
                                      )
                                    }}%</span
                                  >
                                </v-col>
                              </div>
                            </v-col>
                          </div>
                        </v-col>
                        <!--      Celeb-->
                        <v-col cols="12">
                          <div class="row">
                            <v-col
                              class="content-model py-6"
                              style="
                                background-color: whitesmoke;
                                border-radius: 12px;
                              "
                            >
                              <div class="title-chart">
                                <span>Celeb</span>
                              </div>
                              <div
                                class="row no-gutters align-content-center container-bar-chart px-6"
                                v-for="(celeb, idx) in summaryData.celebs.slice(
                                  0,
                                  topView
                                )"
                                :key="idx"
                              >
                                <v-col cols="4">
                                  <span style="text-transform: capitalize">{{
                                    celeb.id
                                  }}</span>
                                </v-col>
                                <v-menu open-on-hover top offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-col cols="7">
                                      <div
                                        v-bind="attrs"
                                        v-on="on"
                                        class="bar-chart"
                                        :style="{
                                          width:
                                            (celeb.total_secs / duration) *
                                              100 +
                                            '%',
                                        }"
                                      ></div>
                                    </v-col>
                                  </template>
                                  <v-card width="600px">
                                    <v-card-text>
                                      <div
                                        class="row no-gutters align-content-center justify-start px-12 pt-4 pb-2"
                                      >
                                        <v-col cols="auto">
                                          <v-avatar size="90">
                                            <v-img
                                              aspect-ratio="1"
                                              :src="celeb.avt"
                                            />
                                          </v-avatar>
                                          <div
                                            class="mt-2"
                                            style="max-width: 150px"
                                          >
                                            <span style="font-weight: bold">
                                              {{ celeb.id }}
                                            </span>
                                            <br />
                                            <small
                                              >All time:
                                              {{
                                                Math.round(
                                                  celeb.total_secs / 60
                                                )
                                              }}m:{{
                                                Math.round(
                                                  celeb.total_secs % 60
                                                )
                                              }}s</small
                                            >
                                          </div>
                                        </v-col>
                                        <v-col>
                                          <div
                                            class="row justify-space-between align-start"
                                          >
                                            <v-col v-if="celeb.emts">
                                              <div
                                                class="row no-gutters align-center small-column"
                                                v-for="(
                                                  emt, idx
                                                ) in celeb.emts.slice(0, 5)"
                                                :key="idx"
                                              >
                                                <v-col cols="4">
                                                  <span>{{ emt.id }}</span>
                                                </v-col>
                                                <v-col cols="7">
                                                  <div
                                                    class="bar-chart-small"
                                                    :style="{
                                                      width:
                                                        (emt.total_secs /
                                                          celeb.total_secs) *
                                                          100 +
                                                        '%',
                                                    }"
                                                  ></div>
                                                </v-col>
                                                <v-col cols="1">
                                                  <span
                                                    style="font-weight: bold"
                                                    >{{
                                                      Math.round(
                                                        (emt.total_secs /
                                                          celeb.total_secs) *
                                                          100
                                                      )
                                                    }}%</span
                                                  >
                                                </v-col>
                                              </div>
                                            </v-col>
                                            <v-col v-if="celeb.acts">
                                              <div
                                                class="row no-gutters align-center justify-start small-column"
                                                v-for="(
                                                  act, idx
                                                ) in celeb.acts.slice(0, 5)"
                                                :key="idx"
                                              >
                                                <v-col cols="4">
                                                  <span>{{ act.id }}</span>
                                                </v-col>
                                                <v-col cols="7">
                                                  <div
                                                    class="bar-chart-small"
                                                    :style="{
                                                      width:
                                                        (act.total_secs /
                                                          celeb.total_secs) *
                                                          100 +
                                                        '%',
                                                      backgroundColor: 'teal',
                                                    }"
                                                  ></div>
                                                </v-col>
                                                <v-col cols="1">
                                                  <span
                                                    style="font-weight: bold"
                                                    >{{
                                                      Math.round(
                                                        (act.total_secs /
                                                          celeb.total_secs) *
                                                          100
                                                      )
                                                    }}%</span
                                                  >
                                                </v-col>
                                              </div>
                                            </v-col>
                                          </div>
                                        </v-col>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-menu>
                                <v-col cols="1">
                                  <span style="font-weight: bold"
                                    >{{
                                      Math.round(
                                        (celeb.total_secs / duration) * 100
                                      )
                                    }}%</span
                                  >
                                </v-col>
                              </div>
                            </v-col>
                          </div>
                        </v-col>
                        <!--                      Colors-->
                        <v-col
                          cols="12"
                          class="content-model py-6"
                          style="
                            background-color: whitesmoke;
                            border-radius: 12px;
                          "
                        >
                          <div class="title-chart">
                            <span>Colors</span>
                          </div>
                          <div
                            class="row no-gutters justify-content-around align-content-center"
                          >
                            <pie-chart
                              :data="summaryData.colors.dist"
                              :colors="summaryData.colors.color"
                            />
                          </div>
                        </v-col>
                      </div>
                    </v-container>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
            <!--            header panel-->
            <div class="close-panel" v-if="showPrPanel" role="user">
              <div class="title-panel-close justify-space-between">
                <span class="mr-12">Metadata panel</span>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ attrs, on }">
                    <v-icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      left
                      color="white"
                      class=""
                      >{{ mdiFilter }}
                    </v-icon>
                  </template>
                  <v-list dense tile flat height="80vh" class="overflow-y-auto">
                    <v-list-item
                      v-for="(item, idx) in allModels"
                      :key="idx"
                      link
                    >
                      <v-checkbox
                        :on-icon="mdiCheck"
                        :off-icon="mdiUnCheck"
                        v-model="item.active"
                      ></v-checkbox>
                      <v-list-item-title
                        @click="item.active = !item.active"
                        v-text="item.name"
                      ></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </transition>
      </v-col>
    </div>
    <!--  End   -->
  </div>
</template>

<script>
import ContentSameShowcase from "./components/ContentSameShowcase";
import Player from "./components/Player";
import { playerShowcase } from "../../minxin/player-showcase";
import PieChart from "./components/PieChart";
// import SceneMetaData from "@/assets/data/SceneMeta.json";
// import StatisticData from "@/assets/data/statisticVideo.json";
import _ from "lodash";
import Plyr from "plyr";
import { mdiFilter, mdiCheckboxBlankOutline, mdiCheckboxMarked } from "@mdi/js";
// import axios from "axios";
export default {
  name: "ShowCaseAllModel",
  components: { PieChart, Player, ContentSameShowcase },
  mixins: [playerShowcase],
  data() {
    return {
      showPrPanel: true,
      mdiFilter: mdiFilter,
      mdiUnCheck: mdiCheckboxBlankOutline,
      mdiCheck: mdiCheckboxMarked,
      allModels: [
        {
          name: "Age",
          active: true,
        },
        {
          name: "Gender",
          active: true,
        },
        {
          name: "Scenes",
          active: true,
        },
        {
          name: "Common Objects",
          active: true,
        },
        {
          name: "Celebs",
          active: true,
        },
        {
          name: "Emotions",
          active: true,
        },
        {
          name: "Actions",
          active: true,
        },
        {
          name: "Colors",
          active: true,
        },
      ],
      series: [[0, 0]],
      loops: [],
      topView: 10,
      currentMeta: {},
      // data statistic for all video
    };
  },
  methods: {
    async _absGetDataShowcase() {},
    async _absGetDataMetaMapping() {},
    _innitVideoPlayer() {
      let video = document.querySelector("#player-video");
      const domPlayerContainer = document.querySelector(".player-container");
      const domAdsContainer = document.querySelector(".ads-container");
      domPlayerContainer.removeChild(domAdsContainer);
      this.plyr = new Plyr(video, {
        captions: { active: true, update: true, language: "en" },
        title: this.title,
        clickToPlay: true,
      });
      this.plyr.on("loadedmetadata", () => {
        if (this.showcaseCr.type_video === "mp4") {
          this.widthVideo = video.videoWidth;
          this.heightVideo = video.videoHeight;
        }
        this.duration = video.duration;
      });
      this.plyr.elements.container.appendChild(domAdsContainer);
      return video;
    },
    _addEventTimeUpdateAndFullScreen(video) {
      const updateAdsPosition = () => {
        if (this.timePlay) {
          const result = _.find(this.showcaseCr.data, (o) => {
            return o["itv"][0] <= this.timePlay && o["itv"][1] >= this.timePlay;
          });
          if (result) {
            this.currentMeta = result.metadata || {};
          } else {
            this.currentMeta = {};
          }
        }
      };
      video.addEventListener("timeupdate", () => {
        this.timePlay = this.video.currentTime;
        updateAdsPosition();
      });
      return video;
    },
  },
  computed: {
    summaryData() {
      return this.showcaseCr.summary_data;
    },
  },
};
</script>

<style scoped lang="scss">
.title-model {
  position: absolute;
  top: -7px;
  left: -7px;
  background-color: gray;
  color: white;
  max-width: 300px;
  border-radius: 0 25px 25px 0;
  padding: 8px 23px;
}

.model-container {
  position: relative;
  margin: 4px 4px 4px 4px;
}

.content-model {
  margin-bottom: 12px;
  min-width: 300px;
  margin-left: 6px;
}
@media (max-width: 576px) {
  .content-model {
    zoom: 0.7;
    margin-left: 2px;
    line-height: 14px;
    margin-bottom: 6px;
  }
  .bar-chart {
    height: 15px !important;
    padding: 1px !important;
    background-color: #1c7430;
    margin-left: 8px !important;
    margin-right: 8px !important;
    margin-bottom: 8px !important;
    border-radius: 2px;
  }
}
.pie {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.legend {
  height: 12px;
  width: 12px;
  margin-right: 4px;
}

.header-section {
  //background-color: #0b2e13;
  padding: 2px 4px;
  text-align: center;
  width: 30%;
  border-radius: 8px;
}

.container-bar-chart {
  text-align: justify; /* For Edge */
  -moz-text-align-last: right; /* For Firefox prior 58.0 */
  text-align-last: right;
  font-size: 12px;
  font-weight: bold;
}

.bar-chart {
  height: 20px;
  padding: 4px;
  background-color: #1c7430;
  margin-left: 8px;
  margin-bottom: 2px;
  border-radius: 2px;
}

.small-column {
  text-align: justify; /* For Edge */
  -moz-text-align-last: right; /* For Firefox prior 58.0 */
  text-align-last: right;
  font-size: 9px;
}

.bar-chart-small {
  height: 12px;
  padding: 2px;
  background-color: #1c7430;
  margin-left: 4px;
  margin-bottom: 2px;
  border-radius: 1px;
}

.container-celeb {
  background-color: white;
  padding: 30px 30px 12px 20px;
  height: 100%;
  width: 600px;
  overflow: hidden !important;
}

.title-chart {
  font-size: 16px;
  font-weight: bold;
  margin-top: -7px;
  margin-left: 20px;
  margin-bottom: 23px;
}
</style>
